__turbopack_context__.v({
  "about": "AboutTheProduct-module-scss-module__bsuR-W__about",
  "about__bullets": "AboutTheProduct-module-scss-module__bsuR-W__about__bullets",
  "about__guide-trigger": "AboutTheProduct-module-scss-module__bsuR-W__about__guide-trigger",
  "about__heading": "AboutTheProduct-module-scss-module__bsuR-W__about__heading",
});
